import { GlobeAltIcon } from "@heroicons/react/24/solid";
import Image from "componentsTemplate/Image";
import SectionSubscribe2 from "componentsTemplate/SectionSubscribe2/SectionSubscribe2";
import SocialsList from "componentsTemplate/SocialsList/SocialsList";
import VerifyIcon from "componentsTemplate/VerifyIcon";
import React, { ReactNode, useEffect, useState } from "react";
import { avatarImgs } from "contains/fakeData";
import NcImage from "componentsTemplate/NcImage/NcImage";
import banner from "../../assets/images/banners/radar_banner_perfil.jpg";
import PerfilService from "services/PerfilService";
import { toast } from "react-toastify";

type LayoutProps = {
  children: ReactNode;
  user: any;
};

const Layout = ({ children, user }: LayoutProps) => {
  const [userImg, setUserImg] = useState("");
  const [fileImg, setFileImg] = useState("");

  useEffect(() => {
    if(fileImg == "") return;
    enviarImagem();
  }, [fileImg]);

  const enviarImagem = async () => {
    let caminhoFile = `/user/${user.id}/update-phofile-photo`;

    await PerfilService.uploadFilePerfil(fileImg, caminhoFile)
      .then((response: any) => {
        if (response.status == 'success') {
          toast.success("Foto editada com sucesso!");
        } else {
          // alert(response.response.data.message);
          toast.error(response.response.data.message);
        }
      })
      .catch((error: any) => {
        //console.error("veio pra ca: ", error);
      });
  };

  return (
    <>
      {/* HEADER */}
      <div className="w-full">
        <div className="relative w-full h-40 md:h-60 2xl:h-72">
          <NcImage
            alt=""
            containerClassName="absolute inset-0"
            sizes="(max-width: 1280px) 100vw, 1536px"
            src={banner}
            className="object-cover w-full h-full"
            fill
          />
        </div>
        <div className="container -mt-10 lg:-mt-16">
          <div className="relative bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 p-1 lg:p-8 rounded-3xl md:rounded-[40px] shadow-xl flex flex-col md:flex-row">
            <div className="w-32 lg:w-40 flex-shrink-0 mt-12 sm:mt-0">
              {/* <input
                type="file"
                id="fileImage"
                className="hidden"
                onChange={onChangeImg}
                accept="image/png, image/jpeg, image/jpg"
              /> */}
              <div
                // onClick={() => alterarFoto()}
                className="ms-3 wil-avatar relative flex-shrink-0 inline-flex items-center justify-center overflow-hidden text-neutral-100 uppercase font-semibold rounded-full w-20 h-20 text-xl lg:text-2xl lg:w-36 lg:h-36 ring-4 ring-white dark:ring-0 shadow-2xl z-0"
              >
                <Image
                  alt="Avatar"
                  src={
                    userImg == ""
                      ? process.env.REACT_APP_BACKEND_API_URL +
                        "/storage/users/" +
                        user.avatar_path
                      : userImg
                  }
                  fill
                  className="object-cover click grayscale"
                />
              </div>
            </div>
            {/*  */}
            {/* <div className="pt-5 md:pt-1 lg:ml-6 xl:ml-12 flex-grow">
              <div className="max-w-screen-sm space-y-3.5 ">
                <h2 className="inline-flex items-center text-2xl sm:text-3xl lg:text-4xl font-semibold">
                  <span>
                    {(user.name ?? "") + " " + (user.last_name ?? "")}
                  </span>
                  <VerifyIcon
                    className="ml-2"
                    iconClass="w-6 h-6 sm:w-7 sm:h-7 xl:w-8 xl:h-8"
                  />
                </h2>
                <div
                  className="block text-sm text-neutral-500 dark:text-neutral-400"
                  dangerouslySetInnerHTML={{ __html: user.bibliography ?? "" }}
                ></div>
                <a
                  href="##"
                  className="flex items-center text-xs font-medium space-x-2.5 cursor-pointer text-neutral-500 dark:text-neutral-400 truncate"
                >
                  <GlobeAltIcon className="flex-shrink-0 w-4 h-4" />
                  <span className="text-neutral-700 dark:text-neutral-300 truncate">
                    {user.email ?? ""}
                  </span>
                </a>
                <SocialsList user={user} itemClass="block w-7 h-7" />
              </div>
            </div> */}

            <div className="d-flex ms-5 h-full items-center mt-5">
              <h2 className="inline-flex items-center text-2xl sm:text-3xl lg:text-4xl font-semibold">
                <span>
                  {(user.name ?? "") + " " + (user.last_name ?? "")}
                </span>
                <VerifyIcon
                  className="ml-2"
                  iconClass="w-6 h-6 sm:w-7 sm:h-7 xl:w-8 xl:h-8"
                />
              </h2>
              <div
                className="block text-sm text-neutral-500 dark:text-neutral-400"
                dangerouslySetInnerHTML={{ __html: user.bibliography ?? "" }}
              ></div>
            </div>

            {/*  */}
            {/* <div className="absolute md:static left-5 right-5 top-4 sm:left-auto sm:top-5 sm:right-5 flex justify-end">
              <FollowButton
                isFollowing={false}
                fontSize="text-sm md:text-base font-medium"
                sizeClass="px-4 py-1 md:py-2.5 h-8 md:!h-10 sm:px-6 lg:px-8"
              />

              <div className="mx-2">
                <NcDropDown
                  className="flex-shrink-0 flex items-center justify-center focus:outline-none h-10 w-10 bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700 text-neutral-700 dark:text-neutral-200 rounded-full"
                  renderTrigger={() => <ShareIcon className="h-5 w-5" />}
                  onClick={() => {}}
                  data={SOCIALS_DATA}
                />
              </div>

              <AccountActionDropdown containerClassName="h-10 w-10 bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700" />
            </div> */}
          </div>
        </div>
      </div>
      {/* ====================== END HEADER ====================== */}
      <div className={`nc-LayoutPage relative`}>
        <div
          className={`absolute h-[400px] top-0 left-0 right-0 w-full bg-primary-100 dark:bg-neutral-800 bg-opacity-25 dark:bg-opacity-40`}
        />
        <div className="container relative pt-6 sm:pt-10 pb-16 lg:pt-20 lg:pb-28">
          {/* CONTENT */}
          <div className="p-1 mx-auto bg-white rounded-xl sm:rounded-3xl lg:rounded-[40px] shadow-lg sm:p-10 lg:p-16 dark:bg-neutral-900">
            {children}
          </div>
        </div>

        {/* <div className="container pb-16 lg:pb-28">
      <SectionSubscribe2 />
    </div> */}
      </div>
    </>
  );
};

export default Layout;
